export default __webpack_public_path__ + "static/media/character-1-instructions.4cff9248.png";